import React, { Component } from "react";
import { Select, Checkbox, Button, Icon, Tooltip, Form, InputNumber, message } from "antd";
import LangContext from "../../contextProvider/LangContext";
import GenericModal from "../../components/GenericModal";
import GenericSelector from "../../components/GenericSelector";
import { Job, OutputType, ProcessType, User } from "../../JmReact";
import SelectorItemClassic from "../../components/SelectorItemClassic";



class FoodDishDetailsAddExtraMulti extends Component {
    state = {
        modalEdit: false,
        selectorChecked: [],
        price: 0,
        percent: 0,
        itemCode: null,
        itemName: null,
        extraType: null,
    }

    static contextType = LangContext;
    getText = (id) => this.context.get(id) || '[' + id + ']';

    sendAPI = (script, data, sCal) => {
        let user = new User(this.props.user.token, this.props.user.companyCode);
        let job = new Job(user, script, OutputType.OUTPUT_TYPE_DATA, ProcessType.PROCESS_TYPE_SYNC);
        job.setInput(data);
        job.send("/cgi-bin/CashOnTab", sCal, (e) => { console.error(e) });
    }

    onSave = () => {
        const { itemCode, extraType, price, percent, selectorChecked } = this.state
        this.sendAPI("create_food_details_extra_multi", { itemCode, extraType, price, percent, idList: selectorChecked.join(",") }, () => {
            message.success(this.getText(21985))
            this.onCancel()
            this.props.refreshData()
        })
    }


    onCancel = () => {
        this.setState({
            modalEdit: false,
            selectorChecked: [],
            price: 0,
            percent: 0,
            itemCode: null,
            itemName: null,
            extraType: null,
        })
    }

    onClear = () => {
        this.setState({
            selectorChecked: [],
            price: 0,
            percent: 0,
            itemCode: null,
            itemName: null,
            extraType: null,
        })
    }


    render() {
        return (<>
            <Tooltip title={this.getText(21987)}>
                <Button key={"DetailsAddExtraMultiBtn"} className={"btn"} style={{ marginTop: "5px", marginLeft: "5px" }} onClick={() => {
                    this.setState({ modalEdit: true })
                }}>
                    <Icon style={{ fontSize: 16 }} className={"clickable margin-4"} type={"shopping-cart"} />
                </Button>
            </Tooltip>
            <GenericModal
                visible={this.state.modalEdit}
                onCancel={() => { this.setState({ modalEdit: false }) }}
                title={this.getText(21988)}
                width={500}
                footer={[
                    <Button onClick={this.onCancel}>{this.getText(21981)}</Button>,
                    <Button onClick={this.onClear}>{this.getText(21986)}</Button>,
                    <Button type="primary" disabled={!this.state.selectorChecked.length} onClick={this.onSave}>{this.getText(21982)}</Button>,
                ]}
            >
                <GenericSelector
                    {...this.props}
                    multi
                    value={this.state.selectorChecked}
                    onChange={e => { this.setState({ selectorChecked: e }) }}
                />
                <Form.Item label={this.getText(21989)}>
                    <SelectorItemClassic
                        {...this.props}
                        valueId={this.state.itemCode}
                        valueName={this.state.itemName}
                        onChange={(itemCode, itemName) => { this.setState({ itemCode, itemName }) }}
                    />
                </Form.Item>
                <Form.Item label={this.getText(21990)}>
                    <GenericSelector
                        {...this.props}
                        dataset={[
                            { code: '2', name: this.getText(12681) },
                            { code: '3', name: this.getText(12680) },
                            { code: '4', name: this.getText(12728) }
                        ]}
                        value={this.state.extraType}
                        onChange={e => { this.setState({ extraType: e }) }}
                    />
                </Form.Item>
                <Form.Item label={this.getText(21983)}>
                    <InputNumber
                        min={0}
                        value={this.state.price}
                        onChange={e => { this.setState({ price: e, percent: 0 }) }}
                    />
                </Form.Item>
                <Form.Item label={this.getText(21984)}>
                    <InputNumber
                        min={0}
                        max={100}
                        value={this.state.percent}
                        onChange={e => { this.setState({ price: 0, percent: e }) }}
                    />
                </Form.Item>
            </GenericModal>
        </>)
    }

}
export default FoodDishDetailsAddExtraMulti;